module.exports = __webpack_public_path__ + "img/edge_divers_web.b68cc8a4.svg";